import React from 'react'
import { cn } from '@utils/safeTs'
import { UtenteType } from '@utils/types'
import { Avatar, Tooltip } from '@components/atoms'
import styles from './AvatarGroup.module.sass'

export interface AvatarGroupProps {
  id: string
  utenti: UtenteType[]
  variant?: 'chat' | 'incaricato'
  ariaLabel?: string
  dialog?: boolean
  className?: string
}

export default function AvatarGroup({
  id,
  utenti,
  variant = 'chat',
  ariaLabel,
  dialog = false,
  className,
}: AvatarGroupProps) {
  if (!utenti?.length) {
    return null
  }

  const max = 3
  const visible = utenti.slice(0, max)
  const rest = utenti.length - visible.length

  return utenti?.length ? (
    <div className={cn(styles.root, className)} aria-label={ariaLabel}>
      {visible.map((u) => (
        <Avatar id={`${id}_${u.id}`} key={u.id} variant={variant} utente={u} dialog={dialog} />
      ))}
      {rest > 0 ? (
        <div className={styles.moreWrap}>
          <Tooltip id={`${id}_more`} pos="top" dialog={dialog} label={utenti.slice(max).map(x => `${x.nome} ${x.cognome}`).join(", ")}>
            <span className={styles.more}>
              ...
            </span>
          </Tooltip>
        </div>
      ) : null}
    </div>
  ) : <></>
}
